import {
    RaikoButtonPrimary,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoMoneyInputOutlined,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    RaikoToggleOutlined, showServerErrorMessage,
    showSuccessMessage,
    showWarningMessage,
    RaikoFlexAlignEnd, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useState} from "react";
import React from "react";
import {useAuthState} from "../../context/AuthContext";
import {OtherPaymentsService} from "../otherPayments/OtherPaymentsService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function AddNewOtherPayment({addNewItemToTable}) {
    const [title, setTitle] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [unit, setUnit] = useState("");
    const [paid, setPaid] = useState("");
    const [expirationDate, setExpirationDate] = useState(false);
    const [description, setDescription] = useState("");
    const [state, setState] = useState(false);
    const [loading, setLoading] = useState(false);

    const service = new OtherPaymentsService()

    const {fundID} = useAuthState()


    function checkAllInputs() {
        let message = ""
        let state = false

        if (title.length === 0)
            message = "لطفا عنوان را به درستی وارد نمایید."
        else if (startDate.length === 0)
            message = "لطفا تاریخ شروع را به درستی وارد نمایید."
        else if (endDate.length === 0)
            message = "لطفا تاریخ پایان را به درستی وارد نمایید."
        else if (unit.length === 0)
            message = "لطفا واحد را به درستی وارد نمایید."
        else if (paid.length === 0)
            message = "لطفا مقدار را به درستی وارد نمایید."
        else if (description.length === 0)
            message = "لطفا توضیحات را به درستی وارد نمایید."
        else
            state = true
        if (message && message.length > 0)
            showWarningMessage(message)
        return state

    }

    function handleAddNewOtherPayment() {
        if (checkAllInputs()) {
            setLoading(true)
            service.addNewOtherPayment(
                fundID,
                title,
                startDate,
                endDate,
                unit,
                paid,
                expirationDate,
                description,
                state
            ).then(response => {
                showSuccessMessage("تراکنش جدید با موفقیت افزوده شد.")
                addNewItemToTable(response)
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setLoading(false)
            })
        }
    }


    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoGridThreeColumn>
                <RaikoSimpleInputOutlined
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                />
                <RaikoDatePicker
                    label={"تاریخ شروع"}
                    date={startDate}
                    setDate={setStartDate}
                />
                <RaikoDatePicker
                    label={"تاریخ پایان"}
                    date={endDate}
                    setDate={setEndDate}
                />
            </RaikoGridThreeColumn>
            <RaikoGridTwoColumn>
                <RaikoToggleOutlined
                    checked={expirationDate}
                    setChecked={setExpirationDate}
                    labelText={"با تاریخ انقضا / بدون تاریخ انقضا"}
                />
                <RaikoToggleOutlined
                    checked={state}
                    setChecked={setState}
                    labelText={"فعال / غیر فعال"}
                />
                <RaikoSimpleInputOutlined
                    labelText={"واحد"}
                    placeHolder={"کیلوگرم،کارتن،عدد و ..."}
                    value={unit}
                    setValue={setUnit}
                />
                <RaikoMoneyInputOutlined
                    labelText={"مبلغ (ریال)"}
                    value={paid}
                    setValue={setPaid}
                />
            </RaikoGridTwoColumn>
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات"}
                value={description}
                setValue={setDescription}
            />
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"افزودن"}
                    onClick={handleAddNewOtherPayment}
                    loading={loading}
                />
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}